module.exports = __webpack_public_path__ + "img/sender-du-ikke-lige-2.f64015eb.png";